var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from 'class-transformer';
export class AgreementPriceListInfoDto {
    id;
    name;
}
__decorate([
    Expose(),
    __metadata("design:type", String)
], AgreementPriceListInfoDto.prototype, "id", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], AgreementPriceListInfoDto.prototype, "name", void 0);
/**
 * Search result row for the agreement-creation price-list-item picker.
 * Used by payer domains where the agreement pins a `priceListId` at sign-time
 * (self-pay, PKV). Each row represents one (priceList, priceListItem) pair, so
 * the same BSI in two lists surfaces twice with different prices and badges.
 */
export class AgreementPriceListItemSearchResultDto {
    priceListItemId;
    billableServiceItemId;
    posNumber;
    displayName;
    priceGross;
    copayment;
    priceList;
}
__decorate([
    Expose(),
    __metadata("design:type", String)
], AgreementPriceListItemSearchResultDto.prototype, "priceListItemId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], AgreementPriceListItemSearchResultDto.prototype, "billableServiceItemId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], AgreementPriceListItemSearchResultDto.prototype, "posNumber", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], AgreementPriceListItemSearchResultDto.prototype, "displayName", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], AgreementPriceListItemSearchResultDto.prototype, "priceGross", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], AgreementPriceListItemSearchResultDto.prototype, "copayment", void 0);
__decorate([
    Expose(),
    Type(() => AgreementPriceListInfoDto),
    __metadata("design:type", AgreementPriceListInfoDto)
], AgreementPriceListItemSearchResultDto.prototype, "priceList", void 0);
//# sourceMappingURL=agreement-price-list-item-search-result.dto.js.map